const actions = {
  SET_STATE: 'dashboard/SET_STATE',
  FETCH_SALES_AGENT_BY_ID: 'dashboard/FETCH_SALES_AGENT_BY_ID',
  FETCH_AGENT_COMMISSION: 'dashboard/FETCH_AGENT_COMMISSION',
  FETCH_AGENT_YEARLY_COMMISSION: 'dashboard/FETCH_AGENT_YEARLY_COMMISSION',
  FETCH_MERCHANT_FEE: 'dashboard/FETCH_MERCHANT_FEE',
  FETCH_SUB_AGENTS: 'dashboard/FETCH_SUB_AGENTS',
  CREATE_SUB_AGENT: 'dashboard/CREATE_SUB_AGENT',
  ASSIGN_MERCHANT_TO_SUB_AGENT: 'dashboard/ASSIGN_MERCHANT_TO_SUB_AGENT',
  FETCH_PAYOUT_HISTORY: 'dashboard/FETCH_PAYOUT_HISTORY',
}

export default actions
